<template>
    <div style="display: flex; flex-direction: column; position: relative;">
        <ModalHeader title="마이페이지" :is-show-back-btn="false" :is_left_area_custom="false" ></ModalHeader>
        <div style="overflow:auto; flex:1; padding:20px;">
            <div style="max-width: 170px;" class="form-group">
                <label class="required">이름</label>
                <input
                        type="text"
                        v-model="formData.name"
                        ref="member_name"
                        enterkeyhint="next"
                        readonly
                >
            </div>

            <div class="form-group">
                <label class="required">휴대폰번호</label>
                <div class="phone-input-group" style="display:flex; ">
                    <input
                            type="text"
                            v-model="formData.phone"
                            style="outline: none; width: inherit; width: 220px;"
                            ref="phone_el"
                            maxlength="13"
                            inputmode="numeric"
                            :readonly="isVerified"
                    >

                    <ProgressButton
                            :buttonText="isShowVerificationInput ? '재전송' : '인증번호전송'"
                            :showProgress="isSendingCode"
                            @click="sendVerificationCode"
                            :customFontSize="'16px'"
                            style="margin-top:0px; width:120px; margin-left: -20px;"
                    />
                </div>
            </div>

            <div class="form-group" v-if="isShowVerificationInput">
                <label class="required">인증번호</label>
                <div style="display: flex;"  class="verification-input-group">
                    <input
                            type="text"
                            v-model="formData.authNumber"
                            maxlength="6"
                            style="width: 150px; outline: none;"
                            :readonly="isVerified"
                            inputmode="numeric"
                    >
                    <div style="width: 70px;">
                        <ProgressButton
                                :buttonText="isVerified ? '인증됨' : '확인'"
                                :showProgress="isVerifying"
                                @click="verifyCode"
                                :customFontSize="'16px'"
                                style="margin-top: 0; margin-left: -20px;"
                                :style="{backgroundColor : isVerified ? 'gray' : ''}"
                        />
                    </div>
                </div>
            </div>

            <div style="max-width: 230px;" class="form-group">
                <label class="required">비상 연락처</label>
                <div class="phone-input-group" style="display:flex;">
                    <input
                            type="tel"
                            v-model="formData.phone2"
                            style="flex:1;"
                            ref="phone_el2"
                            maxlength="13"
                    >
                </div>
            </div>

            <div style="max-width: 250px;" class="form-group">
                <label class="required">급여 통장 은행</label>
                <select style="border-radius: 12px; box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);" v-model="formData.bank_name" ref="bank_name_el">
                    <option v-for="each, i in BANKS" :key="i" :value="each.name">{{each.name}}</option>
                </select>
            </div>

            <div style="max-width: 250px;" class="form-group">
                <label class="required">급여 통장 번호</label>
                <input
                        type="text"
                        v-model="formData.bank_account"
                        ref="bank_account_el"
                        inputmode="numeric"
                        enterkeyhint="next"
                >
            </div>

            <div style="max-width: 250px;" class="form-group">
                <label >급여 통장 명</label>
                <input
                        type="text"
                        v-model="formData.bank_account_name"
                        ref="bank_account_name"
                        placeholder=""
                        enterkeyhint="next"
                >
            </div>

            <div style="max-width: 250px;" class="form-group">
                <label >차량 번호</label>
                <input
                        type="text"
                        v-model="formData.car_number"
                        ref="car_number"
                        placeholder=""
                        enterkeyhint="next"
                >
            </div>

            <div style="max-width: 250px;" class="form-group">
                <label >소개자</label>
                <input
                        type="text"
                        v-model="formData.introducer"
                        ref="introducer"
                        placeholder=""
                        enterkeyhint="next"
                >
            </div>

            <div class="form-group">
                <label>신분증 사본</label>
                <div>
                    <ProgressButton
                            :buttonText="is_image_uploaded ? '재업로드' : '업로드'"
                            @click="selectFile"
                            style="margin-top:0px;"
                            :customFontSize="'16px'"
                    />
                    <input type="file" ref="image_file" style="display:none;" :capture="!is_ios" @change="readURL($event, 'image_preview')"/>
                    <img v-show="is_show_image_preview" ref="image_preview" style="margin-top:10px; border-radius:4px; width:100%;"/>
                </div>
            </div>

            <div style="display:grid; place-items: center;">
                <ProgressButton
                        buttonText="수정하기"
                        :showProgress="isSubmitting"
                        @click="submit"
                        style="margin-top:0px; width: 118px;"
                        :customFontSize="'24px'"
                />

            </div>

        </div>
        <PageBottom />
    </div>
</template>

<script>
    import ModalHeader from "../common/ModalHeader";
    import PageBottom from "../common/PageBottom";
    import {BANKS} from "../../Constants";
    import ProgressButton from "../common/ProgressButton";
    import ResponseCode from "../../ResponseCode";
    export default {
        name: "MyPage",
        components: {ProgressButton, PageBottom, ModalHeader},
        data(){
            return {
                BANKS : BANKS,
                formData : {
                    name : '',
                    phone : '',
                    authNumber : '',
                    bank_name : '',
                    bank_account : '',
                    bank_account_name : '',
                    phone2 : '',
                    car_number : '',
                    introducer : '',
                },
                isVerified : false,
                isSendingCode : false,
                isVerifying : false,
                isShowVerificationInput : false,
                isSubmitting: false,
                is_image_uploaded : false,
                is_show_image_preview : false,
            }
        },
        computed : {
            is_ios(){
                const device = this.$cookies.get('device');
                return device === 'ios';
            },
        },
        methods : {
            selectFile(){
                this.$refs.image_file.click();
            },
            readURL(e, target) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();

                    if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp') {

                        var reader = new FileReader();
                        reader.onload = (e) => {
                            this.$refs[target].src = e.target.result;
                        }
                        reader.readAsDataURL(input.files[0]);
                        this.is_image_uploaded = true;
                        this.is_show_image_preview = true;
                    } else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp만 업로드 가능합니다.');
                    }
                }
            },
            async sendVerificationCode(){
                const parameters = {};
                parameters.phone = this.formData.phone;
                this.isSendingCode = true;
                const res = await this.$Axios.post('/api/auth/number', parameters);
                this.isSendingCode = false;
                if(res.data.code === ResponseCode.SUCCESS){
                    this.$GlobalStore.showAlert('인증번호가 전송되었습니다.');
                    this.isShowVerificationInput = true;
                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async submit(){
                if(this.isShowVerificationInput && !this.isVerified){
                    this.$GlobalStore.showAlert('인증번호를 인증해주세요.');
                    return;
                }

                if(this.phone === ''){
                    this.$GlobalStore.showAlert('연락처를 입력해주세요.');
                    return;
                }

                const phone2_format = /\d{3}-\d{4}-\d{4}/gi;
                if(!phone2_format.test(this.formData.phone2)){
                    this.$GlobalStore.showAlert('비상연락처의 휴대폰번호 형식이 맞지 않습니다.');
                    this.$refs.phone_el2.focus();
                    return;
                }

                if(this.formData.bank_name === ''){
                    this.$GlobalStore.showAlert('급여통장 은행을 선택해주세요.');
                    this.$refs.bank_name_el.scrollIntoView({block : 'center'});
                    return false;
                }

                if(this.formData.bank_account === ''){
                    this.$GlobalStore.showAlert('급여통장 번호를 입력해주세요.');
                    this.$refs.bank_account_el.focus();
                    return false;
                }

                if(this.formData.bank_account_name === ''){
                    this.$GlobalStore.showAlert('급여통장명을 입력해주세요.');
                    this.$refs.bank_account_el.focus();
                    return false;
                }

                this.isSubmitting = true;

                const parameters = {};
                Object.assign(parameters, this.formData);

                const formData = new FormData();
                for(const key in parameters){
                    console.log(key, parameters[key]);
                    formData.append(key, parameters[key]);
                }

                if(this.$refs.image_file.value !== '') formData.append('image_file', this.$refs.image_file.files[0]);

                this.isSubmitting = true;
                const res = await this.$Axios.post('/api/member/mine/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                this.isSubmitting = false;
                if(res.data.code === ResponseCode.SUCCESS){
                    this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                    this.getMyInfo();
                    await this.$Util.checkAfterLogin();
                    this.$GlobalStore.showAlert('수정하였습니다.');
                    this.resetForm();

                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async verifyCode(){
                if(this.isVerified) return;

                const parameters = {};
                parameters.phone = this.formData.phone;
                parameters.authNumber = this.formData.authNumber;
                this.isVerifying = true;
                const res = await this.$Axios.post('/api/auth/check', parameters);
                this.isVerifying = false;
                if(res.data.code === ResponseCode.SUCCESS){
                    this.isVerified = true;
                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            resetForm(){
                this.isVerified = false;
                this.isSendingCode = false;
                this.isVerifying = false;
                this.isShowVerificationInput = false;
                this.isSubmitting = false;
            },
            async getMyInfo(){
                const res = await this.$Axios.get('/api/member/mine');
                const member = res.data.member;
                this.formData.name = member.name;
                this.formData.phone = member.phone;
                this.formData.phone2 = member.phone2;
                this.formData.bank_name = member.bank_name;
                this.formData.bank_account = member.bank_account;
                this.formData.bank_account_name = member.bank_account_name;
                this.formData.car_number = member.car_number;
                this.formData.introducer = member.referrer ?? '';
                if(res.data.identification_image_str) {
                    this.is_show_image_preview = true;
                    this.$refs.image_preview.src = 'data:image/png;base64,' + res.data.identification_image_str;
                } else {
                    this.is_show_image_preview = false;
                }
            }
        },
        created(){
            this.submit = this.$Once(this.submit);

            this.getMyInfo();
        }

    }
</script>

<style scoped>
    .form-group {
        margin-bottom: 30px;
    }

    label {
        display: block;
        margin-bottom: 7px;
        font-weight: bold;
        color:var(--font-black-color);
    }

    /*label.required{*/
    /*color:#ff4b00;*/
    /*}*/

    .gender_wrapper {
        display:flex;
        align-items: center;
        padding:12px 16px;
        border-radius: 12px;
        box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);
    }

    input {
        width: 100%;
        padding: 12px;
        /*border: 1px solid #ddd;*/
        border-radius: 12px;
        font-size: 14px;
        height: 44px;
        border: none;
        box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);
    }

    input:read-only{
        background-color: lightgrey;
    }


    select {
        width: 100%;
        padding: 0px 6px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        height: 44px;
        background-color: white;
        color:black;
    }

    button {
        padding: 8px 16px;
        background-color: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        height: 44px;
    }

    button:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }

    textarea{
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        height: 44px;
    }

</style>